{
  "07e1519cd01a1150": "Charting status",
  "0c3ce3fefa044ee7": "Charting recall created successfully",
  "0eb0d01798771592": "Recall note",
  "0ed27b1c0f670221": "Charting verified successfully for {{workerName}}",
  "11a6767d5674c7e4": "Done",
  "1298f382394c84cd": "All caught up — no recalls in progress",
  "19766ed6ccb2f4a3": "Cancel",
  "19c73a5cdf346d96": "Professional",
  "19e13435115479ea": "Recall again",
  "22b8701f928b506a": "All license types",
  "253304095a1bcdd2": "No matching shifts during this time range",
  "294fa874ea6514e3": "Recall note:",
  "2e544a292f6979ed": "Shift",
  "2e71da3a95d291bc": "Search for a professional",
  "2f040e8849968259": "Error reporting {{workerName}}: {{message}}",
  "31bd5db3eee7a15e": "Create recall",
  "31e392d1c0378bec": "Apply",
  "3e0c029234155245": "Shift date",
  "546ebb8eb993ea56": "Filters",
  "557623c48457054d": ". They have {{hours}} hour to return to your workplace and ensure your records are audit-ready.",
  "58bb31253b227e14": "Report as incomplete",
  "5a1f27056c4bc26e": "Please confirm that {{workerName}} has completed all outstanding documentation for this shift at your workplace. You will not be able to recall them again for this shift.",
  "5bc8cd7dfb5f5ec0": "Recall to chart",
  "5e231b20808f1921": "Error recalling {{workerName}}: {{message}}",
  "66d50aca56da2386": ". They have {{hours}} hours to return to your workplace and ensure your records are audit-ready.",
  "72f256afd196ceae": "License type",
  "78d066e77b15d04e": "Charting was not started",
  "7eb8b42fec603757": "In-progress recalls",
  "7fce8c12f5c04833": "Charting was partially complete",
  "875c63a7d3bce041": "Please leave a note for the professional specifying which part of the charting was incomplete.",
  "88b4e196562e9d6c": "Yes, mark charting as complete",
  "8a8fd5cf53233987": "Shift date range",
  "9255b9f3385cf9ed": "Error verifying charting for {{workerName}}: {{errorMessage}}",
  "95e445f6311803b9": "All shifts",
  "973845052fa7ac8b": "Filter charting reports",
  "a472b75dd9eff44b": "Charting Compliance Manager",
  "a8283ade31856f71": "Undo",
  "b41fd589ad91ed78": "Submit report",
  "c170bc77f0f09ba4": "Reported by",
  "c286ef143acc2459": "If a professional leaves charting incomplete, you can recall them to complete it",
  "c8ed5004a3a6e5d0": "Has {{workerName}} returned to complete charting?",
  "cbd247e4246f0cb2": "Recall {{workerName}} to complete charting",
  "d34fef882db4af9b": "Selected range",
  "d8d623efaf5a6057": "Charting report created successfully",
  "daee7606b339f3c3": "Reset",
  "de0b992e815a9143": "Open charting filters",
  "eb1348d4c4294fe6": "Provide details on what still needs to be completed (e.g. vitals, meds, progress notes)",
  "eea2745e2867a677": "Verify",
  "f91e0c5b9e2b5ec3": "free of charge",
  "fbac2fb49360402d": "Report incomplete charting"
}
